import React, { useState, useEffect } from "react";
import { Button, notification, Tooltip, Form } from "antd";
import style from "../../index.module.scss";
import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";
import { InboxOutlined } from "@ant-design/icons";
import boxApi from "api/box";
import TableBox from "features/sushi/components/TableBox";
import ModalCUBox from "features/sushi/components/ModalCUBox";
import { handleUploadImage } from "utils/index";
import imageApi from "api/image";
import FormFilter from "features/sushi/components/FormFilter";
import { boxOptions } from "constants/index";

const cx = classNames.bind(style);

export default function BoxPage() {
  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  const { t } = useTranslation();

  const [openModalCU, setOpenModalCU] = useState(false);
  const [openModalDel, setOpenModalDel] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(false);

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({ message, description });
  };

  const onOpenModalCU = (item) => {
    item && setSelected(item)
    setOpenModalCU(true)
  }

  const onOpenModalDelete = (item) => {
    item && setSelected(item)
    setOpenModalDel(true)
  }

  const onCloseModalCU = () => {
    setOpenModalCU(false)
    setSelected(null)
    form.resetFields();
  }

  const fetchBox = async () => {
    try {
      setLoading(true)
      const res = await boxApi.getAllBox({ 
        name: formSearch.getFieldValue('name'),
        ...(formSearch.getFieldValue('type') && { type: formSearch.getFieldValue('type') })
      });
      setData(res.box || [])
    } catch (error) {
      console.log("🚀 ~ error:", error)
    } finally {
      setLoading(false)
    }
  }

  const onSubmitCU = async (values) => {
    try {
      setLoading(true)
      if (selected) {
        let imageId = selected.imageId
        let imageUrl = selected.imageUrl

        if (values.imageBox[0]?.uid !== "-1") {
          imageId && await imageApi.deleteImage(imageId);
          const { success, result } = await handleUploadImage(values.imageBox[0]);
          if (!success) {
            openNotificationWithIcon("error", t('error'), t('hasError'));
            return;
          }
          imageId = result?.public_id;
          imageUrl = result?.url;
        }
        const res = await boxApi.updateBox(selected._id, {
          ...values,
          imageId,
          imageUrl
        });
        if (res?.success) {
          openNotificationWithIcon("success", t('notification'), t('success'));
          onCloseModalCU();
          fetchBox()
        }
      } else {
        const { success, result } = await handleUploadImage(values.imageBox[0]);
        if (!success) {
          openNotificationWithIcon("error", t('error'), t('hasError'));
          return;
        }
        const res = await boxApi.createBox({
          ...values,
          imageId: result?.public_id,
          imageUrl: result?.url
        });
        if (res?.success) {
          openNotificationWithIcon("success", t('notification'), t('success'));
          onCloseModalCU();
          fetchBox()
        }
      }
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchBox()
  }, [])


  return (
    <div className={cx("page-sushi")}>
      {contextHolder}
      <div className={cx("title")}>
        <p>{t("boxSushi")}</p>
        <Button onClick={() => onOpenModalCU()}>
          <Tooltip title={t("addBox")}>
            <InboxOutlined />
          </Tooltip>
        </Button>
      </div>
      <FormFilter loading={loading} form={formSearch} submit={fetchBox} options={boxOptions} /> 
      <TableBox
        loading={loading}
        dataSource={data}
        onOpenModalUpdate={onOpenModalCU}
        onOpenModalDelete={onOpenModalDelete}
        fetchBox={fetchBox}
        openNotificationWithIcon={openNotificationWithIcon}
      />
      <ModalCUBox
        form={form}
        openModal={openModalCU}
        onCloseModal={onCloseModalCU}
        selected={selected}
        onSubmit={onSubmitCU}
      />

    </div>
  );
}
